import { z } from 'zod';

import { BorrowerId } from '../../../BrandedIds';
import { PaymentDeferralWorkoutPlan } from '../../../loan/WorkoutPlan';
import { BaseLoanEvent } from '../../BaseLoanEvent';

export const CreatePaymentDeferralWorkoutPlanEvent = BaseLoanEvent.extend({
  type: z.literal('createPaymentDeferralWorkoutPlan'),
  data: PaymentDeferralWorkoutPlan.pick({
    reason: true,
    endDate: true, // offer expiration date
    startStatementDate: true,
    endStatementDate: true,
    chargeIds: true,
    paymentDueIds: true,
    quotedDeferredBalances: true,
    escrowAnalysisId: true,
    acceptanceMethod: true,
    acceptanceMethodOther: true,
  }).extend({
    sendAgreementTo: z.array(BorrowerId),
  }),
});
export type CreatePaymentDeferralWorkoutPlanEvent = z.infer<typeof CreatePaymentDeferralWorkoutPlanEvent>;
